import { bindActionCreators } from "redux";
import * as siteConfigActions from "../redux/actions/site.config.actions";
import { connect } from "react-redux";
import React, { useEffect } from "react";
import {Button, Form, InputNumber, Switch, Typography, Divider} from 'antd';
import {swalNotification} from "../components/alret/notificztion";

const { Title } = Typography;

const SiteConfig = (props) => {
  const [form] = Form.useForm();

  useEffect(() => {
    props.siteConfigActions.listAction("");
  }, []);

  useEffect(() => {

    if (props.pageData && Array.isArray(props.pageData)) {
      const values = {};
      props.pageData.forEach(item => {
        values[item.slug] = item.value;
      });

      form.setFieldsValue(values);
    }
  }, [props.pageData]);

  const onFinish = async (values) => {

    try {

      const payload = Object.keys(values).map((key) => ({
        slug: key,
        value: values[key] === true ? 1 : values[key] === false ? 0 : values[key], // Convert booleans to 1/0
      }));

      const response = await props.siteConfigActions.patchAction(payload);

      if (response?.data && response?.data?.error === false) {
        swalNotification(
          "Site Config",
          response?.data?.message || 'Configuration updated successfully',
          "success"
        );
        props.siteConfigActions.listAction("");
      }

    } catch (error) {
      swalNotification(
        "Site Config",
        error.response?.data?.message || 'Something went wrong',
        "error"
      );
    }

  };

  return (
    <div className="page-content">
      <div className="page-content-header">
        <div className="pch">
          <Title level={2}>Site Config</Title>
        </div>
        <div className="pch"></div>
      </div>
      <div className="p-content custom-config">
        <Form
          form={form}
          name="site_config_form"
          layout="vertical"
          // labelCol={{ span: 16 }}
          // wrapperCol={{ span: 8 }}
          onFinish={onFinish}
        >
          <div style={{maxWidth: "400px"}}>
            <Form.Item label="Order Limit in Cron" name="stacking_limit" rules={[
              { required: true, message: 'Please enter the Order Limit' },
              {
                type: 'number',
                min: 1,
                max: 30,
                message: 'Order Limit must be between 1 and 30',
              },
            ]}>
              <InputNumber min={1} max={30} style={{ width: '100%' }} />
            </Form.Item>
            <Form.Item label="OTP Limit" name="otp_limit" rules={[
              { required: true, message: 'Please enter the OTP Limit' },
              {
                type: 'number',
                min: 1,
                max: 100,
                message: 'OTP Limit must be between 1 and 100',
              },
            ]}>
              <InputNumber min={1} max={100} style={{ width: '100%' }} />
            </Form.Item>
            <Form.Item label="Order Status Change Limit" name="order_status_change_limit" rules={[
              { required: true, message: 'Please enter the Order Status Change Limit' },
              {
                type: 'number',
                min: 1,
                max: 100,
                message: 'Order Status Change Limit must be between 1 and 100',
              },
            ]}>
              <InputNumber min={1} max={100} style={{ width: '100%' }} />
            </Form.Item>
            <Form.Item label="Shift Start Wallet Threshold" name="shift_start_wallet_threshold" rules={[
              { required: true, message: 'Please enter the Shift Start Wallet Threshold' },
              {
                type: 'number',
                min: 1,
                max: 10000,
                message: 'Shift Start Wallet Threshold must be between 1 and 10000',
              },
            ]}>
              <InputNumber min={1} max={10000} style={{ width: '100%' }} />
            </Form.Item>
            <Form.Item name="restrict_rider_on_register" label="Restrict Rider to register if profile match:" valuePropName="checked" >
              <Switch />
            </Form.Item>
            <Form.Item name="selfie_restrict_shift_start" label="Restrict Rider to Start Start if selfie not match:" valuePropName="checked" >
              <Switch />
            </Form.Item>
            <Form.Item name="show_unpacked_orders" label="Show un-packed orders packer app:" valuePropName="checked" >
              <Switch />
            </Form.Item>
          </div>
          <Divider orientation="left" style={{borderColor: "#333"}}>Web</Divider>
          <div style={{maxWidth: "400px"}}>
            <Form.Item name="show_customer_phone_number" label="Show customer phone number:" valuePropName="checked" >
              <Switch />
            </Form.Item>
          </div>
          <Divider orientation="left" style={{borderColor: "#333"}}>Application</Divider>
          <div style={{maxWidth: "400px"}}>
            <Form.Item name="hide_customer_location_on_app" label="Hide customer location on rider app:" valuePropName="checked" >
              <Switch />
            </Form.Item>
            <Form.Item name="hide_customer_name_on_app" label="Hide customer name on rider app:" valuePropName="checked" >
              <Switch />
            </Form.Item>
          </div>
          <Divider orientation="left" style={{borderColor: "#333"}}>Rider can call customer only within order radius</Divider>
          <div style={{maxWidth: "400px"}}>
            <Form.Item name="customer_phone_visible_within_radius_enabled" label="Enable logic to check order radius:" valuePropName="checked" >
              <Switch />
            </Form.Item>
            <Form.Item label="Rider and Order distance (in meters): " name="customer_phone_visible_within_radius_config_value" rules={[
              { required: true, message: 'Please enter the rider and order distance (in meters)' }
            ]}>
              <InputNumber style={{width: "100%"}} />
            </Form.Item>
          </div>
          <Divider orientation="left" style={{borderColor: "#333"}}>Issue Cron</Divider>
          <div style={{maxWidth: "400px"}}>
          <Form.Item name="enable_order_not_accepted_cron" label="Order Not Accepted Issue Cron:" valuePropName="checked" >
            <Switch />
          </Form.Item>
          <Form.Item name="enable_order_not_packed_cron" label="Order Not Packed Issue Cron:" valuePropName="checked" >
            <Switch />
          </Form.Item>
          <Form.Item name="enable_order_not_picked_up_cron" label="Order Not Picked Up Issue Cron:" valuePropName="checked" >
            <Switch />
          </Form.Item>
          <Form.Item name="enable_order_is_partial_cron" label="Order Is Partial Issue Cron:" valuePropName="checked" >
            <Switch />
          </Form.Item>
          <Form.Item name="enable_new_customer_order_cron" label="New Customer Order Issue Cron:" valuePropName="checked" >
            <Switch />
          </Form.Item>
          <Form.Item name="enable_new_customer_order_cancel_cron" label="New Customer Order Cancel Issue Cron:" valuePropName="checked" >
            <Switch />
          </Form.Item>
          <Form.Item name="cx_doorstep_delay_cron_enable" label="Customer Doorstep Delay Issue Cron:" valuePropName="checked" >
            <Switch />
          </Form.Item>
          <Form.Item name="trip_completed_rider_not_at_mart_cron_enable" label="Trip Completed Rider Not At Mart Issue Cron:" valuePropName="checked" >
            <Switch />
          </Form.Item>
          <Form.Item name="delay_order_cron_enable" label="Delay Order Issue Cron:" valuePropName="checked" >
            <Switch />
          </Form.Item>
          </div>
          <Button type="primary" htmlType="submit">
            Update
          </Button>
        </Form>
      </div>
    </div>
  );
};

// Redux bindings
const mapStateToProps = (state) => ({
  pageData: state.SiteConfigReducer.initialData,
  pageLoader: state.SiteConfigReducer.initialLoading,
  pagePagination: state.SiteConfigReducer.initialPagination,
  pageFilter: state.SiteConfigReducer.initialFilter,
  user: state.authReducer.user,
});

const mapDispatchToProps = (dispatch) => ({
  siteConfigActions: bindActionCreators(siteConfigActions, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(SiteConfig);